import React, { Component } from 'react';
import { Col, Row } from 'react-simple-flex-grid';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import Header from 'components/Header';
import { IMAGE_PATHS } from 'libs/constants';
import SideBar from './SideBar';
import './HeaderAndSidebarLayout.scss';

class HeaderAndSidebarLayout extends Component {
  constructor() {
    super();
    this.state = {
      open: false
    };

    this.toggleSidebar = _.debounce(this.toggleSidebar, 200);
  }

  toggleSidebar = () => {
    const { open } = this.state;
    this.setState({
      open: !open
    });
  }

  closeSideBar = () => {
    const { open } = this.state;
    if (open) {
      this.setState({
        open: false
      });
    }
  }
  render() {
    const { open } = this.state;
    const { route, ...restProps } = this.props;
    return (
      <div className="Layout--HeaderAndSidebar">
        <Header
          toggleSidebar={this.toggleSidebar}
          closeSideBar={this.closeSideBar}
          imagePaths={IMAGE_PATHS.defaultHeaderLayout}
          showMenuIconMobile
          showPopover
          hamburgerClass="Layout--HeaderAndSidebar--Header--Hamburger"
          signOutLabelText={<FormattedMessage id="views.headerAndSidebarLayout.header.signOut.text" />}
          contactUsLabelText={<FormattedMessage id="views.headerAndSidebarLayout.header.contactUs.text" />}
        />
        <SideBar open={open} closeSideBar={this.closeSideBar} />
        <div className="Layout--HeaderAndSidebar__Content">
          <Row>
            <Col xs={12} className="Layout--HeaderAndSidebar__OffCanvas">
              { renderRoutes(route.routes, { ...restProps }) }
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

HeaderAndSidebarLayout.propTypes = {
  route: PropTypes.object.isRequired,
};

export default HeaderAndSidebarLayout;



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderAndSidebarLayout/HeaderAndSidebarLayout.jsx